import type { CSSProperties } from "react";
import type { EventPersonalization } from "./types";

const colorPattern = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

function safeColor(value: string | undefined, fallback: string) {
  return value && colorPattern.test(value) ? value : fallback;
}

export function safeAssetUrl(value?: string) {
  if (!value) return "";
  if (value.startsWith("/")) return value;
  try {
    const url = new URL(value);
    return url.protocol === "https:" || url.protocol === "http:" ? value : "";
  } catch {
    return "";
  }
}

function safeCssImage(value?: string) {
  const asset = safeAssetUrl(value);
  if (!asset || /["'()\\\n\r]/.test(asset)) return "";
  return `url("${asset}")`;
}

export function publicEventStyle(event: EventPersonalization | null): CSSProperties {
  const backgroundImage = safeCssImage(event?.optionalBackgroundImage);
  return {
    "--event-primary": safeColor(event?.primaryThemeColor, "#050505"),
    "--event-secondary": safeColor(event?.secondaryThemeColor, "#FFF9EF"),
    "--event-accent": safeColor(event?.accentColor, "#D4AF37"),
    ...(backgroundImage ? { "--event-background-image": backgroundImage } : {}),
  } as CSSProperties;
}
